import styled from "styled-components";
import { Typography } from "antd";
import "./vars.css";

const { Title } = Typography;

export const StyledTitle = styled(Title)`
  color: var(--styled-antd-color-title) !important;
`;